import { MixPanelEventEmitter } from '../../metrics/MixPanelEventEmitter';
import { CARE_CODE_SOURCE, VIEWER_SOURCE_PARAM } from '../ViewerUrlProvider';

/**
 * Reports that someone opened a care profile by scanning a printed Care Code. The marker rides in
 * the URL rather than being inferred, because a Care Code and an ordinary view-only share link
 * exchange their session the same way and are otherwise indistinguishable once the app boots.
 */
export class CareCodeScanTracker {
    static inject = () => [MixPanelEventEmitter];
    constructor(private mixpanel: MixPanelEventEmitter) {}

    private hasTracked = false;

    trackIfArrivedByCareCode = () => {
        if (this.hasTracked) {
            return;
        }

        const query = new URLSearchParams(window.location.search);
        if (query.get(VIEWER_SOURCE_PARAM) !== CARE_CODE_SOURCE) {
            return;
        }

        this.hasTracked = true;
        this.mixpanel.track('Care Code Scanned');

        // Drop the marker so reloading the page doesn't count the same scan again.
        query.delete(VIEWER_SOURCE_PARAM);
        const queryString = query.toString();
        window.history.replaceState({}, '', `${window.location.pathname}${queryString ? `?${queryString}` : ''}${window.location.hash}`);
    };
}
